<template>
  <el-dialog title="反馈搜索的问题" :visible.sync="visible" center width="500px">
    <div class="search-feedback-page" v-loading="loading">
      <p>
        <span>我搜索：</span>
        <el-input
          v-model="keyword"
          placeholder="请输入搜索词"
          size="small"
          :style="{ width: '200px', margin: '0 10px' }"
        />
      </p>
      <p>搜索体验不佳，具体情况如下：</p>
      <el-input
        type="textarea"
        :rows="7"
        placeholder="请输入内容"
        autofocus
        resize="none"
        v-model="content"
      ></el-input>
      <div class="submit-button">
        <el-button type="primary" @click="feedBack" size="small">提交反馈</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { TodaySearchService } from "@/service/search";
import Message from "@/service/message";

export default {
  data() {
    return {
      keyword: "",
      content: "", // 反馈内容
      loading: false,

      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    // 搜索反馈
    async feedBack() {
      if (!this.keyword) return Message.warning("请填写您的搜索词");
      if (!this.content) return Message.warning("请填写反馈内容");
      this.loading = true;
      const res = await TodaySearchService.feedBackPost(
        this.keyword,
        this.content
      );
      if (res.code === 0) {
        this.loading = false;
        this.hide();
        Message.success("感谢您的反馈");
      }
    },
  },
};
</script>
<style lang="less">
.search-feedback-page {
  padding: 0 25px;

  p {
    margin-bottom: 15px;
    font-size: 15px;

    & :nth-child(2) {
      color: #dc0000;
    }
  }
}

.submit-button {
  text-align: center;
  margin-top: 25px;
}
</style>
